/**
 * Notification / Snackbar
 * @constructor
 */
import { styled } from '@mui/material';
import { MaterialDesignContent, SnackbarProvider } from 'notistack';
import React, { createRef, ReactElement } from 'react';

type Props = {
  children: ReactElement | ReactElement[];
};

const StyledMaterialDesignContent = styled(MaterialDesignContent)(() => ({
  '&.notistack-MuiContent-success': {
    backgroundColor: '#5D9E51',
  },
  '&.notistack-MuiContent-error': {
    backgroundColor: '#970C0C',
  },
}));

const SnackBarProvider = (props: Props) => {
  const { children } = props;
  const notistackRef = createRef<any>();

  return (
    <SnackbarProvider
      maxSnack={3}
      ref={notistackRef}
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'center',
      }}
      classes={{
        root: 'snackbar',
      }}
      dense={true}
      Components={{
        success: StyledMaterialDesignContent,
        error: StyledMaterialDesignContent,
      }}
    >
      <>{children}</>
    </SnackbarProvider>
  );
};

export default SnackBarProvider;
